export default "__VITE_ASSET__D9nyM4w7__"